export default {
    "en": {
        "All_Head_Tapbutton1": "Features",
        "All_Head_Tapbutton2": "Curriculum",
        "All_Head_Tapbutton3": "Educator",
        "All_Head_Tapbutton4": "Subscription",
        "All_Head_Tapbutton5": "Account",
        "All_Head_Tapbutton6": "Classroom",
        "All_Footer_Menubutton_Buttonname5": "Help"
    },
    "ko": {
        "All_Head_Tapbutton1": "특징",
        "All_Head_Tapbutton2": "교육과정",
        "All_Head_Tapbutton3": "선생님",
        "All_Head_Tapbutton4": "구독",
        "All_Head_Tapbutton5": "계정",
        "All_Head_Tapbutton6": "학급 모드",
        "All_Footer_Menubutton_Buttonname5": "도움말"
    },
    "cn": {
        "All_Head_Tapbutton1": "系统",
        "All_Head_Tapbutton2": "内容",
        "All_Head_Tapbutton3": "教育专家",
        "All_Head_Tapbutton4": "订阅",
        "All_Head_Tapbutton5": "账户",
        "All_Head_Tapbutton6": "课堂",
        "All_Footer_Menubutton_Buttonname5": "帮助"
    },
    "ja": {
        "All_Head_Tapbutton1": "特徴",
        "All_Head_Tapbutton2": "教育課程",
        "All_Head_Tapbutton3": "教師",
        "All_Head_Tapbutton4": "ライセンス",
        "All_Head_Tapbutton5": "アカウント",
        "All_Head_Tapbutton6": "教室",
        "All_Footer_Menubutton_Buttonname5": "ヘルプ"
    }
}


// WEBPACK FOOTER //
// ./src/text/common/header.js